import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supplyProcurementService } from '../services/apiServices';

const KEYS = {
  all: ['supply-procurements'] as const,
  list: () => [...KEYS.all, 'list'] as const,
};

export const useSupplyProcurements = () =>
  useQuery({ queryKey: KEYS.list(), queryFn: () => supplyProcurementService.getAll() });

export const useCreateSupplyProcurement = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => supplyProcurementService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list() }),
  });
};

export const useUpdateSupplyProcurement = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      supplyProcurementService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list() }),
  });
};

export const useDeleteSupplyProcurement = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => supplyProcurementService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list() }),
  });
};

export const useMakeSupplyPayment = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, amount }: { id: number; amount: number }) =>
      supplyProcurementService.makePayment(id, amount),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.list() }),
  });
};
